import { ProfileRecordStatus } from "@nkr/enums/index";

export interface IMedicalRecord {
    medicalRecordId: number,
    patientScreenId: number,
    patientScreenChoiceId: number,
    source: string,
    birthDate: string,
    firstName: string,
    lastName: string,
    preferredName: string,
    preferredLanguageId: number,
    preferredLanguage: string,
    genderId: number,
    gender: string,
    addressIsUs: number,
    addressLine1: string,
    addressLine2: string,
    city: string,
    stateProvince: string,
    postalCode: string,
    email: string,
    phoneNumber: string,
    phoneNumberSecondary: string,

    ethnicity: number,
    maritalStatus: number,
    employmentStatus: number,
    occupation: string,
    educationLevel: number,
    hasHealthInsurance: number,

    registrationDate: string,
    registrationStatusId: number,
    registrationStatus:string,
    referralStatusId: number,
    referralStatus: string,

    followUpDate: string,

    coordinatorId: number,
    coordinatorName: string,
    hasAboResults: boolean,

    micrositeRecordStatus: ProfileRecordStatus,
    recipientRecordStatus: ProfileRecordStatus,
    declineReason: number | null,
    declineReasonOther: string,
    allowCenterUpdate: boolean,
    //transferRequest: boolean,
    isMicrositeCenter: boolean,
    isDashLiverParticipant: boolean,

    transferRequest: {
        id: number,
        currentCenterId: number,
        currentCenterAlias: string
    }
}

export interface IMedicalRecordResponse extends IMedicalRecord {
    centerId: number
}